import i18next from "i18next";

import { formatDate } from "@shared/utils";

export const formatGeneralDisplayValue = (value: unknown, isDate?: boolean): string => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  if (isDate) {
    const formatted = formatDate(String(value), i18next.language);
    return formatted || "—";
  }
  return String(value);
};
